import { toast } from 'react-toastify';
import 'twin.macro';

const getToastOptions = className => ({
  className,
  closeButton: <button tw="absolute top-4 right-4 text-white" />,
  closeOnClick: true,
  hideProgressBar: true,
  autoClose: true,
  position: window.innerWidth < 480 ? 'bottom-center' : 'bottom-right',
  style:
    window.innerWidth < 480
      ? {
          bottom: '1rem',
          width: 'calc(100% - 2rem)',
          maxWidth: '400px',
          borderRadius: '6px !important',
          padding: '1rem !important',
          fontSize: '14px',
          fontWeight: '500',
        }
      : {},
});

export const showSuccess = message =>
  toast(
    () => (
      <div>
        <div className="toast-title" tw="text-[0.9em] font-[600]">
          {message}
        </div>
      </div>
    ),
    getToastOptions('Toastify__toast--custom')
  );

export const showError = message =>
  toast(
    () => (
      <div>
        <div className="toast-title" tw="text-[0.9em] font-[600]">
          {message}
        </div>
      </div>
    ),
    getToastOptions('Toastify_error__toast--custom')
  );
